const aosAppStoreLink = 'https://play.google.com/store/apps/details?id=co.kr.datau.saturn_aos'

const iosAppStoreLink =
  'https://apps.apple.com/kr/app/%ED%9C%B4%EB%8C%80%ED%8F%B0%EC%BF%A0%ED%8F%B0%EC%A7%80%EA%B0%91-%EC%83%81%EC%8B%9C%ED%95%A0%EC%9D%B8-%ED%8A%B9%EA%B0%80%EC%BF%A0%ED%8F%B0/id6502936747'

const aosOpenApp = (fallBackUrl: string) => {
  return `intent://payment_return#Intent;scheme=couponwalletapp;package=co.kr.datau.saturn_aos;S.browser_fallback_url=${fallBackUrl};end;`
}

// 설치->앱실행, 미설치->스토어
const iosInstallDeepLink = 'https://saturn-app.onelink.me/HxWK/gyx13es9'

// 설치->앱실행, 미설치->인트로
const iosIntroDeepLink = 'https://saturn-app.onelink.me/HxWK/f7wi6c4y'

export { aosAppStoreLink, iosAppStoreLink, aosOpenApp, iosInstallDeepLink, iosIntroDeepLink }
